import type { Drug } from "../../types";

export const liraglutideDrug: Drug = {
  id: "liraglutide",
  name: "Liraglutide (Saxenda®/Biolide®)",
  drugClass: "GLP-1 receptor agonist",
  route: "subcutaneous",
  defaultFoodTiming: "May be administered at any time of day, with or without food",
  administrationNote:
    "Biological product — record brand name (Saxenda® or Biolide®) and batch number at every supply. Compatible needles not included — supply separately.",
  formulations: [
    {
      id: "liraglutide-6mg-3ml-pen",
      type: "prefilled_pen",
      strength: 6,
      strengthUnit: "mg",
      volumePer: 3,
      volumeUnit: "mL",
      brandExample: "Saxenda® or Biolide®",
      storageNote:
        "Store at 2–8°C before first use. Do not freeze. After first use store at ≤30°C or refrigerated for up to 1 month. Shelf life unopened: Saxenda® 30 months, Biolide® 24 months.",
      prescribedItemId: "4b451ce8-9fdd-496e-b71c-2239aa19222b",
    },
  ],
};
